module.exports = __webpack_public_path__ + "img/mkcr.5715f25d.png";